// Import api models.
import {
	DisallowedRequestField,
	EndorsementPreSubmissionAcknowledgements,
	EndorsementResponseCostValues,
	EndorsementResponsePolicyCommercial,
	EndorsementResponsePolicyPersonal,
	EndorsementSubmissionStatusError,
} from '@app/models/api';
// Import enumerations.
import {
	EndorsementStatus,
} from '@app/enumerations';

export default class EndorsementResponse {
	public endorsementDate: Date | null = null;
	public applyAtRenewal: boolean | null = null;
	public canBuildingsBeRemoved: boolean | null = null;
	public areNewBuildingsAllowed: boolean | null = null;
	public status: EndorsementStatus | null = null;
	public endorsementCostValues: EndorsementResponseCostValues | null = null;
	public disallowedFields: DisallowedRequestField[] = [];
	public submissionStatusErrors: EndorsementSubmissionStatusError[] = []
	public preSubmissionAcknowledgements: EndorsementPreSubmissionAcknowledgements | null = null;
	public policyInformationNew: EndorsementResponsePolicyPersonal | EndorsementResponsePolicyCommercial | null = null;
	public policyInformationOld: EndorsementResponsePolicyPersonal | EndorsementResponsePolicyCommercial | null = null;

	public constructor() {

	}
}